// extracted by mini-css-extract-plugin
module.exports = {"o1lc0aja":"o1lc0aja","su8wln2":"su8wln2"};